import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { map, shareReplay, tap } from 'rxjs/operators';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class GenericService {
  private readonly httpClient = inject(HttpClient);

  genericGetCall<T>(url: string): Observable<T> {
    return this.httpClient
      .get<T>(url, { observe: 'response', withCredentials: true })
      .pipe(map((response) => response.body));
  }
}
